import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container py-5"
}
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = { class: "col-md-6 offset-md-3" }
const _hoisted_4 = { class: "card shadow-sm my-10" }
const _hoisted_5 = { class: "card-body text-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-circle-fill fs-5x text-success" }, null, -1)
const _hoisted_7 = { class: "my-7" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h1", { class: "text-center my-10" }, "Registrar cuenta de usuario", -1)
const _hoisted_10 = { class: "row my-5" }
const _hoisted_11 = { class: "col-md-6 offset-md-3" }
const _hoisted_12 = { class: "card" }
const _hoisted_13 = { class: "card-body" }
const _hoisted_14 = { class: "text-center my-5" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-left fs-4" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-right fs-4 text-white" }, null, -1)
const _hoisted_17 = {
  key: 1,
  class: "text-center"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/misc/noavailable.png",
  alt: ""
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h1", { class: "mb-5" }, "!Lo sentimos¡", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "fs-4" }, "Esta asociación no tiene habilitada la opción para registrar nuevas cuentas de usuario", -1)

import { usePublicInstitution } from './composables/usePublicInstitution';

//components
import Header from "@/components/shared/Header.vue"
import Footer from '@/layout/footer/Footer.vue';
import StepInstitution from './steps/StepInstitution.vue';
import StepRepman from './steps/StepRepman.vue';
import StepAccount from './steps/StepAccount.vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'RegisterIndex',
  setup(__props) {

const { loading, steps, dataCompany, form, formRef, nextStep, prevStep, resRegister, listCountries, getCompany } = usePublicInstitution();


return (_ctx: any,_cache: any) => {
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header, {
      avatars: _unref(dataCompany)?.avatars,
      bg: _unref(dataCompany)?.setting?.bg,
      alias: _unref(dataCompany)?.alias
    }, null, 8, ["avatars", "bg", "alias"]),
    (_unref(dataCompany)?.register_clubs == '1')
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_unref(resRegister)?.status == 'success')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _hoisted_6,
                      _createElementVNode("h1", _hoisted_7, "¡" + _toDisplayString(_unref(resRegister).title) + "!", 1),
                      _createElementVNode("p", {
                        class: "fs-5",
                        innerHTML: _unref(resRegister)?.message
                      }, null, 8, _hoisted_8)
                    ])
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_9,
                _createVNode(_component_el_steps, {
                  class: "w-100 mb-10",
                  active: _unref(steps),
                  "align-center": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_step, {
                      title: "Paso 1",
                      description: "Datos de la institución"
                    }),
                    _createVNode(_component_el_step, {
                      title: "Paso 2",
                      description: "Datos del representante"
                    }),
                    _createVNode(_component_el_step, {
                      title: "Paso 3",
                      description: "Datos de la cuenta"
                    })
                  ]),
                  _: 1
                }, 8, ["active"]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_el_form, {
                          ref_key: "formRef",
                          ref: formRef,
                          model: _unref(form),
                          "label-position": "top"
                        }, {
                          default: _withCtx(() => [
                            (_unref(steps) == 1)
                              ? (_openBlock(), _createBlock(StepInstitution, {
                                  key: 0,
                                  form: _unref(form),
                                  listCountries: _unref(listCountries)
                                }, null, 8, ["form", "listCountries"]))
                              : _createCommentVNode("", true),
                            (_unref(steps) == 2)
                              ? (_openBlock(), _createBlock(StepRepman, {
                                  key: 1,
                                  form: _unref(form),
                                  listCountries: _unref(listCountries)
                                }, null, 8, ["form", "listCountries"]))
                              : _createCommentVNode("", true),
                            (_unref(steps) == 3)
                              ? (_openBlock(), _createBlock(StepAccount, {
                                  key: 2,
                                  form: _unref(form)
                                }, null, 8, ["form"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["model"])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  (_unref(steps)>1 && _unref(steps)<=3)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        onClick: _unref(prevStep)
                      }, {
                        default: _withCtx(() => [
                          _hoisted_15,
                          _createTextVNode(" Atras")
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _unref(nextStep)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(steps)>2 ? 'Registrarme' : 'Siguiente') + " ", 1),
                      _hoisted_16
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ], 64))
        ])), [
          [_directive_loading, _unref(loading)]
        ])
      : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_17, [
          _hoisted_18,
          _hoisted_19,
          _hoisted_20,
          _createVNode(_component_el_button, {
            type: "primary",
            class: "my-5",
            onClick: _unref(getCompany)
          }, {
            default: _withCtx(() => [
              _createTextVNode("Volver a intentar")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])), [
          [_directive_loading, _unref(loading)]
        ]),
    _createVNode(Footer)
  ], 64))
}
}

})